import { Component, Input, OnInit } from '@angular/core';
import { ActionsSubject, Store } from '@ngrx/store';
import { LogbookAppState } from '../../../store/logbook.reducer';
import {
  GetNotificationList,
  GetUserFeedToken,
} from '../../../store/user/actions';
import { NotificationList } from '../../../shared/service/notification/notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: false,
})
export class NotificationComponent implements OnInit {
  @Input() isOpened: boolean = false;
  public isFeedTokenLoading$: boolean = false;
  public notificationsLoading$: boolean = false;
  public notificationsLoaded$: boolean = false;
  public notificationList$: NotificationList = { results: [], next: null, duration: null, unseen: 0, unread: 0 };
  public hasNextNotification: boolean = false;

  constructor(private readonly store: Store<LogbookAppState>, private readonly userActions: ActionsSubject) {
    this.store.dispatch(new GetUserFeedToken());
  }

  ngOnInit() {
    this.store.select('user').subscribe((state) => {
      this.isFeedTokenLoading$ = state.isFeedTokenLoading;
      this.notificationsLoading$ = state.notificationsLoading;
      this.notificationsLoaded$ = state.notificationsLoaded;
      this.notificationList$ = state.notifications;
      this.hasNextNotification = this.notificationList$.next !== '' && this.notificationList$.next !== null;
    });
  }

  public loadMoreNotifications(): void {
    if (this.hasNextNotification) {
      this.store.dispatch(new GetNotificationList(false, this.notificationList$.id_lt));
    }
  }
}
